import { openUrl } from '../../../domain/services/LinkService'

export default (url) => {
  openUrl(url, true)
}
